import { District, Ward } from "../models/index";

export class HubRoutingWardViewModel {
    id:number;
    hubId:number;
    wardId:number;
    wardName:string;
    districtId:number;
    districtName:string;
    provinceId:number;
    provinceName:string;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/view-model/hubRoutingWard.viewModel.ts